/* eslint-disable */
import apios from "./apios"
import apiosWithToken from "./apiosWithToken"
export default {
    login(user) {
        return apios.post('/auth/token/', user)
    },
    getSwtichToken() {
        return apiosWithToken.get('/users/token/for/member/')
    },
}